var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outlined/Chevron Down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4775 6.85984C16.7295 7.11828 16.7295 7.53728 16.4775 7.79572L10.456 13.9722C10.2041 14.2306 9.79559 14.2306 9.54364 13.9722L3.52213 7.79572C3.27018 7.53728 3.27018 7.11828 3.52213 6.85984C3.77409 6.60141 4.18258 6.60141 4.43453 6.85984L9.99984 12.5684L15.5651 6.85984C15.8171 6.60141 16.2256 6.60141 16.4775 6.85984Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/Chevron Down.0e226a8cb081c2c0511caf264f0e4731.svg";
export { ForwardRef as ReactComponent };